import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Controller } from 'react-hook-form';
import { CountriesPicker } from '@alycecom/modules';
import { AlyceTheme } from '@alycecom/ui';
import { useSelector } from 'react-redux';

import { ShippingAddressField } from '../../../../store/shipping/shipping.types';
import { TCountry } from '../../../../../../store/countries/countries.types';
import { getCountries } from '../../../../../../store/countries/countries.selectors';

import { TFieldProps, TStandardTextFieldProps } from './Fields';

const useStyles = makeStyles<AlyceTheme>(({ breakpoints }) => ({
  countryPopper: {
    maxWidth: 484,
    width: '484px !important',
    [breakpoints.down('lg')]: {
      maxWidth: 400,
      width: 400,
    },
    [breakpoints.down('sm')]: {
      maxWidth: 320,
      width: 320,
    },
  },
}));

const RecipientCountry = ({ control, disabled }: TStandardTextFieldProps): JSX.Element => {
  const classes = useStyles();
  const countries = useSelector(getCountries);
  return (
    <Controller
      control={control}
      name={ShippingAddressField.Country}
      render={({ onChange, value }) => (
        <CountriesPicker<false, TCountry>
          label="Country *"
          searchLabel="Search country"
          name={ShippingAddressField.Country}
          value={value}
          disabled={disabled}
          onChange={countryValue => {
            if (countryValue) {
              onChange(countryValue);
            }
          }}
          getOptionSelected={(option: TCountry, countryValue: TCountry) => option.id === countryValue.id}
          options={countries}
          multiple={false}
          classes={{
            popper: classes.countryPopper,
          }}
        />
      )}
    />
  );
};

export default memo<TFieldProps>(RecipientCountry);
